import { TimeUtils } from '@front/volcanion/utils'
import { I18n } from '@front/volcanion'

class Callbacks {
  static recordToFormHandler() {
    return function recordToForm(record) {
      const name = record?.service?.contract?.company?.name
      const requestedAt = TimeUtils.formatDateBackToFront(record?.requestedAt)
      const source_cp = record?.source?.postal_code

      const title = _.join(_.compact([_.upperCase(I18n.t('order.label', { count: 1 })), _.compact([name, requestedAt, source_cp]).join(' - ')]), ' ')

      return {
        ...record,
        vehicle_options: _.map(record?.vehicle_opts, 'vehicle_option_id'),
        driver_options: _.map(record?.driver_opts, 'user_option_id'),
        is_paired: true,
        title
      }
    }
  }

  static handleNotifyDriversHandler(sendDriverMessage) {
    return async function handleNotifyDrivers(values) {
      const { type, job, title, important, vehicle_options, driver_options, is_paired } = values
      await sendDriverMessage({ data: { job, type, title, important, vehicle_options, driver_options, is_paired } })
    }
  }

  static getNotifyDriversFailedNotificationHandler() {
    return function getNotifyDriversFailedNotification(error, values, extra, meta, state) {
      return [I18n.t('toast.comment.error.default'), { variant: 'error' }]
    }
  }
}

export default Callbacks
